import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Landmark, ArrowRight, ArrowDown } from "lucide-react";
import { FEATURED_PLAN } from "@/lib/featured";

const FeaturedPlanCard = () => {
  return (
    <section className="bg-hero pb-12 md:pb-16 -mt-px">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-[var(--radius)] bg-white/[0.03] text-hero-fg border border-white/10 shadow-card overflow-hidden backdrop-blur-sm"
        >
          <div className="p-6 md:p-10">
            <div className="flex items-start gap-4 mb-5">
              <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                <Landmark className="h-5 w-5 text-accent" />
              </div>
              <div className="min-w-0">
                <div className="text-accent text-[11px] font-semibold tracking-[0.2em] uppercase mb-1">
                  Our Current Case Study · {FEATURED_PLAN.location}
                </div>
                <h2 className="font-display text-2xl md:text-4xl font-bold leading-tight">
                  Executing the {FEATURED_PLAN.fullTitle}
                </h2>
                <p className="text-hero-muted text-sm md:text-base mt-3 max-w-2xl leading-relaxed">
                  A city-adopted strategy to close Mobile's wealth gap — banking access, DBE
                  ownership, and priority-zip revitalization. Every idea below is an initiative
                  moving one part of this plan forward.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mt-6 md:pl-[60px]">
              {FEATURED_PLAN.stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3"
                >
                  <div className="font-display text-2xl md:text-3xl font-bold text-accent">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-hero-muted mt-1 leading-snug">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-7 md:pl-[60px] flex flex-wrap items-center gap-4">
              <Link
                to={FEATURED_PLAN.href}
                className="inline-flex items-center gap-1.5 rounded-full bg-accent text-accent-foreground font-display font-semibold text-sm px-5 h-10 hover:bg-accent/90 transition-colors"
              >
                Read the analysis
                <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href="#initiatives"
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-hero-fg hover:text-hero-fg"
              >
                <ArrowDown className="h-4 w-4" />
                See initiatives advancing it
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedPlanCard;